module.exports = __webpack_public_path__ + "img/pills.7d936af3.svg";